function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.84,207.22c-7.12-27.28-19-52.72-31.36-70.17-29.78-41.94-99-60.4-146.87-42.83-40.77,15-55,60.23-90.65,81.91-32.76,20-62.49,36.2-73.95,74.22-24.2,80.31,71.51,144.33,143,124,22.58-6.43,41.66-19.95,65.74-20,48.85-.17,66.05,6.53,105.57-19.85C435.28,308.42,437.3,255,424.84,207.22Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.84,207.22c-7.12-27.28-19-52.72-31.36-70.17-29.78-41.94-99-60.4-146.87-42.83-40.77,15-55,60.23-90.65,81.91-32.76,20-62.49,36.2-73.95,74.22-24.2,80.31,71.51,144.33,143,124,22.58-6.43,41.66-19.95,65.74-20,48.85-.17,66.05,6.53,105.57-19.85C435.28,308.42,437.3,255,424.84,207.22Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Machine--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.22,305l1.28-.59-.27-1.54-1.42-.11a5.92,5.92,0,0,0-.71-1.34l.73-1.24-1.11-1.11-1.24.74a6.33,6.33,0,0,0-2.38-1l-.36-1.42h-1.56l-.36,1.43a6.45,6.45,0,0,0-1.41.45l-1.12-1-1.29.9.53,1.38a7.28,7.28,0,0,0-.9,1.17l-1.47-.15-.54,1.47,1.22.83a7.17,7.17,0,0,0-.08,1c0,.15,0,.3,0,.44l-1.28.72.4,1.51,1.46,0a5.56,5.56,0,0,0,.8,1.27l-.63,1.31,1.2,1,1.16-.83a6.39,6.39,0,0,0,1.4.59l.24,1.41,1.56.13.47-1.33a5.81,5.81,0,0,0,1.5-.32l1,1,1.36-.78-.37-1.35a6.61,6.61,0,0,0,1-1.14l1.38.25.66-1.42-1.08-.89A6.4,6.4,0,0,0,216.22,305Zm-2.32,0a3.92,3.92,0,1,1-3.91-3.91A3.91,3.91,0,0,1,213.9,305Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.16,305l1.29-.59-.27-1.54-1.42-.11a5.92,5.92,0,0,0-.71-1.34l.73-1.24-1.11-1.11-1.24.74a6.33,6.33,0,0,0-2.38-1l-.36-1.42h-1.56l-.36,1.43a6.45,6.45,0,0,0-1.41.45l-1.12-1-1.29.9.53,1.38a7.28,7.28,0,0,0-.9,1.17l-1.47-.15-.54,1.47,1.22.83a7.17,7.17,0,0,0-.08,1c0,.15,0,.3,0,.44l-1.28.72.4,1.51,1.46,0a5.56,5.56,0,0,0,.8,1.27l-.63,1.31,1.2,1,1.16-.83a6.39,6.39,0,0,0,1.4.59l.24,1.41,1.56.13.47-1.33a5.81,5.81,0,0,0,1.5-.32l1,1,1.36-.78-.37-1.35a6.61,6.61,0,0,0,1-1.14l1.38.25.66-1.42-1.08-.89A5.92,5.92,0,0,0,328.16,305Zm-2.31,0a3.92,3.92,0,1,1-3.91-3.91A3.91,3.91,0,0,1,325.85,305Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.5,
    y: 298.01,
    width: 10,
    height: 50.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.5,349.25h-10a.5.5,0,0,1-.5-.5V298a.5.5,0,0,1,.5-.5h10a.5.5,0,0,1,.5.5v50.74A.5.5,0,0,1,276.5,349.25Zm-9.5-1h9V298.51h-9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.51,
    y: 315.31,
    width: 23.98,
    height: 70.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.49,386h-24a.5.5,0,0,1-.5-.5V315.31a.5.5,0,0,1,.5-.5h24a.5.5,0,0,1,.5.5v70.16A.5.5,0,0,1,283.49,386ZM260,385h23V315.81H260Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.71,
    y: 315.31,
    width: 3.57,
    height: 70.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.29,386h-3.58a.51.51,0,0,1-.5-.5V315.31a.5.5,0,0,1,.5-.5h3.58a.5.5,0,0,1,.5.5v70.16A.51.51,0,0,1,273.29,386Zm-3.08-1h2.58V315.81h-2.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 295.97,
    width: 250.83,
    height: 8.67,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.83,305.14H171a.5.5,0,0,1-.5-.5V296a.5.5,0,0,1,.5-.5H421.83a.5.5,0,0,1,.5.5v8.67A.5.5,0,0,1,421.83,305.14Zm-250.33-1H421.33v-7.67H171.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.12,305.1a.5.5,0,0,1-.5-.5v-8.12a.5.5,0,0,1,1,0v8.12A.5.5,0,0,1,202.12,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.46,305.1a.5.5,0,0,1-.5-.5v-8.12a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.12A.5.5,0,0,1,210.46,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.81,305.1a.5.5,0,0,1-.5-.5v-8.12a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v8.12A.5.5,0,0,1,218.81,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.15,305.1a.5.5,0,0,1-.5-.5v-8.12a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v8.12A.5.5,0,0,1,227.15,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.49,305.1a.5.5,0,0,1-.5-.5v-8.12a.5.5,0,0,1,1,0v8.12A.5.5,0,0,1,235.49,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.83,305.1a.5.5,0,0,1-.5-.5v-8.12a.5.5,0,0,1,1,0v8.12A.5.5,0,0,1,243.83,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.17,305.1a.5.5,0,0,1-.5-.5v-8.12a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.12A.5.5,0,0,1,252.17,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.51,305.1a.5.5,0,0,1-.5-.5v-8.12a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.12A.5.5,0,0,1,260.51,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.86,305.1a.5.5,0,0,1-.5-.5v-8.12a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v8.12A.5.5,0,0,1,268.86,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.2,305.1a.5.5,0,0,1-.5-.5v-8.12a.5.5,0,0,1,1,0v8.12A.5.5,0,0,1,277.2,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.54,305.1a.5.5,0,0,1-.5-.5v-8.12a.5.5,0,0,1,1,0v8.12A.5.5,0,0,1,285.54,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.88,305.1a.5.5,0,0,1-.5-.5v-8.12a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.12A.5.5,0,0,1,293.88,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.22,305.1a.5.5,0,0,1-.5-.5v-8.12a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.12A.5.5,0,0,1,302.22,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.57,305.1a.5.5,0,0,1-.5-.5v-8.12a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v8.12A.5.5,0,0,1,310.57,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.91,305.1a.5.5,0,0,1-.5-.5v-8.12a.5.5,0,0,1,1,0v8.12A.5.5,0,0,1,318.91,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.25,305.1a.5.5,0,0,1-.5-.5v-8.12a.5.5,0,0,1,1,0v8.12A.5.5,0,0,1,327.25,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.59,305.1a.5.5,0,0,1-.5-.5v-8.12a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.12A.5.5,0,0,1,335.59,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.93,305.1a.5.5,0,0,1-.5-.5v-8.12a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.12A.5.5,0,0,1,343.93,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.28,305.1a.5.5,0,0,1-.5-.5v-8.12a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v8.12A.5.5,0,0,1,352.28,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.62,305.1a.5.5,0,0,1-.5-.5v-8.12a.5.5,0,0,1,1,0v8.12A.5.5,0,0,1,360.62,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.31 230.9 102.53 230.9 63.85 281.11 63.85 385.47 187.31 385.47 187.31 299.63 187.31 230.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.31,386H63.85a.5.5,0,0,1-.5-.5V281.11a.51.51,0,0,1,.1-.3l38.69-50.21a.47.47,0,0,1,.39-.2h84.78a.5.5,0,0,1,.5.5V385.47A.5.5,0,0,1,187.31,386Zm-123-1H186.81V231.4h-84L64.35,281.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.33,
    y: 229.3,
    width: 7.33,
    height: 84,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67,313.8h-7.34a.5.5,0,0,1-.5-.5v-84a.51.51,0,0,1,.5-.5h7.34a.51.51,0,0,1,.5.5v84A.5.5,0,0,1,191.67,313.8Zm-6.84-1h6.34v-83h-6.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.75,
    cy: 314.39,
    r: 4.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75,319.14a4.75,4.75,0,1,1,4.75-4.75A4.76,4.76,0,0,1,81.75,319.14Zm0-8.5a3.75,3.75,0,1,0,3.75,3.75A3.75,3.75,0,0,0,81.75,310.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.75,
    cy: 335.89,
    r: 4.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75,340.64a4.75,4.75,0,1,1,4.75-4.75A4.76,4.76,0,0,1,81.75,340.64Zm0-8.5a3.75,3.75,0,1,0,3.75,3.75A3.75,3.75,0,0,0,81.75,332.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,385.64a.5.5,0,0,1-.5-.5v-88.5a.5.5,0,0,1,.5-.5h24.5v-65a.5.5,0,0,1,1,0v65.5a.5.5,0,0,1-.5.5H95.5v88A.5.5,0,0,1,95,385.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7,370.14H63.94a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H94.7a.5.5,0,0,1,.5.5A.5.5,0,0,1,94.7,370.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.33,
    y: 340.64,
    width: 5,
    height: 5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.33,346.14h-5a.51.51,0,0,1-.5-.5v-5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,104.33,346.14Zm-4.5-1h4v-4h-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 340.64,
    width: 5,
    height: 5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,346.14h-5a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,112,346.14Zm-4.5-1h4v-4h-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.67,
    y: 340.64,
    width: 5,
    height: 5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.67,346.14h-5a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v5A.51.51,0,0,1,119.67,346.14Zm-4.5-1h4v-4h-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.33,
    y: 349.97,
    width: 5,
    height: 5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.33,355.47h-5a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,104.33,355.47Zm-4.5-1h4v-4h-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 349.97,
    width: 5,
    height: 5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,355.47h-5a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,112,355.47Zm-4.5-1h4v-4h-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.67,
    y: 349.97,
    width: 5,
    height: 5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.67,355.47h-5a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,119.67,355.47Zm-4.5-1h4v-4h-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.33,
    y: 359.3,
    width: 5,
    height: 5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.33,364.8h-5a.5.5,0,0,1-.5-.5v-5a.51.51,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,104.33,364.8Zm-4.5-1h4v-4h-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 359.3,
    width: 5,
    height: 5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,364.8h-5a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5v5A.5.5,0,0,1,112,364.8Zm-4.5-1h4v-4h-4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.67,
    y: 359.3,
    width: 5,
    height: 5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.67,364.8h-5a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,1,.5-.5h5a.51.51,0,0,1,.5.5v5A.5.5,0,0,1,119.67,364.8Zm-4.5-1h4v-4h-4Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.89,375.39a18.64,18.64,0,0,0,4.75,4.3c2.49,1.36,6.79,2.94,6.79,4.07v1.14H133.51l.23-10Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.43,385.4H133.51a.51.51,0,0,1-.5-.52l.23-10a.48.48,0,0,1,.16-.35.46.46,0,0,1,.37-.13l8.15.45a.54.54,0,0,1,.37.19,18.2,18.2,0,0,0,4.59,4.17c.7.38,1.57.79,2.41,1.19,2.88,1.36,4.64,2.25,4.64,3.32v1.14A.5.5,0,0,1,153.43,385.4Zm-19.41-1h18.91v-.64c-.08-.53-2.68-1.76-4.07-2.42-.85-.4-1.73-.82-2.46-1.21a18.42,18.42,0,0,1-4.76-4.25l-7.41-.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.51,384.9h19.92v-1.14c0-.32-.36-.69-.93-1.07H133.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.43,385.4H133.51a.51.51,0,0,1-.5-.52l.05-2.21a.5.5,0,0,1,.5-.48H152.5a.54.54,0,0,1,.28.08c.54.37,1.15.87,1.15,1.49v1.14A.5.5,0,0,1,153.43,385.4Zm-19.41-1h18.91v-.64s0-.18-.59-.57H134.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,298.64s.67,25.66.67,28.66-3,9-3.67,15-2.26,32.64-2.26,32.64h8s5.59-27.3,8.59-39.64,5-42.33,5-42.33H140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.74,375.44h-8a.51.51,0,0,1-.5-.53c0-.27,1.6-26.72,2.26-32.66a48.79,48.79,0,0,1,2.27-9.24,23.3,23.3,0,0,0,1.4-5.71c0-3-.66-28.39-.67-28.65a.34.34,0,0,1,0-.1l1-5.67a.49.49,0,0,1,.49-.41h15.33a.52.52,0,0,1,.37.16.5.5,0,0,1,.13.37c0,.3-2,30.19-5,42.42s-8.53,39.34-8.59,39.62A.5.5,0,0,1,141.74,375.44Zm-7.47-1h7.06c.71-3.43,5.75-27.87,8.52-39.26s4.66-37.63,5-41.71H140.42l-.92,5.2c0,1.28.67,25.72.67,28.63a23.62,23.62,0,0,1-1.45,6,47.62,47.62,0,0,0-2.22,9C135.89,347.81,134.5,370.65,134.27,374.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.4,279s-.45,11.09.91,14.94,3.39,11.32,3.39,11.32,2.49,18.56,2.49,21.51-2.94,10.64-2.94,16.75,2.49,31.47,2.49,31.47l8.15.45s4.53-31.24,6.56-42.79,2.27-29,1.59-34.41-.45-18.79-.45-18.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.89,375.89h0l-8.15-.46a.5.5,0,0,1-.47-.45c-.1-1-2.49-25.44-2.49-31.51,0-3.67,1-7.9,1.88-11.3a29.75,29.75,0,0,0,1.06-5.45c0-2.88-2.46-21.26-2.48-21.44,0,0-2-7.44-3.38-11.22s-1-14.67-.93-15.13a.48.48,0,0,1,.51-.48l22.19.45a.52.52,0,0,1,.49.51c0,.13-.22,13.38.45,18.72.64,5.14.52,22.59-1.59,34.56-2,11.41-6.52,42.46-6.57,42.77A.49.49,0,0,1,149.89,375.89Zm-7.69-1.43,7.26.4c.57-3.89,4.62-31.68,6.5-42.34,2.1-11.88,2.22-29.18,1.58-34.27-.61-4.87-.5-15.85-.46-18.36l-21.2-.43c-.06,2.18-.25,11,.9,14.27,1.35,3.82,3.38,11.27,3.4,11.35.12.82,2.51,18.69,2.51,21.64a29.67,29.67,0,0,1-1.09,5.69c-.82,3.35-1.85,7.51-1.85,11.06C139.75,349.05,141.87,371.11,142.2,374.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.85 273.38 162.33 266.33 178.89 253.45 187.47 259.74 167.85 273.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.85,273.88a.5.5,0,0,1-.4-.19l-5.51-7.05a.51.51,0,0,1-.11-.37.53.53,0,0,1,.19-.33l16.56-12.88a.49.49,0,0,1,.6,0l8.59,6.29a.5.5,0,0,1,0,.81l-19.63,13.64A.47.47,0,0,1,167.85,273.88ZM163,266.42,168,272.7l18.66-13-7.71-5.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.7 271.8 163.85 265.61 178.4 254.29 185.94 259.82 168.7 271.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.7,272.05a.25.25,0,0,1-.19-.09l-4.85-6.2a.24.24,0,0,1,0-.18.26.26,0,0,1,.09-.17l14.55-11.31a.26.26,0,0,1,.3,0l7.54,5.52a.23.23,0,0,1,.1.21.25.25,0,0,1-.1.2l-17.24,12A.28.28,0,0,1,168.7,272.05Zm-4.49-6.4,4.55,5.81,16.75-11.65-7.1-5.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,260.05s3.68-2.3,4.91-2.46,6.29.46,6.59,1.08,0,1.38-.61,1.38-4.75-.92-4.75-.92l-2.76,2.3s5.67-.16,5.67.76-1.53,1.07-2.3.92a30.33,30.33,0,0,0-3.53-.15c-.46,0-2.6,1.53-4.29,1.53h-2.6l-.62-2.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.94,265h-2.6a.5.5,0,0,1-.49-.37l-.61-2.3a.51.51,0,0,1,.26-.58l4.27-2.13c.47-.3,3.81-2.35,5.09-2.51.83-.1,6.57.28,7.1,1.34a1.6,1.6,0,0,1,0,1.53,1.19,1.19,0,0,1-1,.57c-.58,0-3.58-.64-4.62-.87l-1.49,1.24c1.7,0,3.93.15,4.53.73a.76.76,0,0,1,.24.55,1.22,1.22,0,0,1-.47,1,3.3,3.3,0,0,1-2.43.44,25.52,25.52,0,0,0-3.43-.14c-.07,0-.45.21-.75.36A8.62,8.62,0,0,1,162.94,265Zm-2.22-1h2.22a8.06,8.06,0,0,0,3.09-1.06,3.07,3.07,0,0,1,1.2-.47,27.67,27.67,0,0,1,3.63.16,2.35,2.35,0,0,0,1.59-.23.22.22,0,0,0,.08-.09,18.44,18.44,0,0,0-5.13-.38.5.5,0,0,1-.48-.32.48.48,0,0,1,.15-.56l2.76-2.3a.47.47,0,0,1,.43-.1c2,.44,4.28.9,4.64.9a.17.17,0,0,0,.16-.1.58.58,0,0,0,0-.55,20.81,20.81,0,0,0-6.09-.8,21.52,21.52,0,0,0-4.7,2.38l0,0-3.93,2ZM164,260Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.34 264.49 150.52 267.56 150.98 262.19 159.72 262.19 160.34 264.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.52,268.06a.51.51,0,0,1-.31-.11.5.5,0,0,1-.18-.44l.46-5.36a.49.49,0,0,1,.49-.46h8.74a.5.5,0,0,1,.49.37l.61,2.3a.5.5,0,0,1-.34.61L150.67,268Zm.92-5.37-.35,4.17,8.64-2.7-.39-1.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.06,238.88s4.07,8.83,4.53,15.62,1.58,22.19,1.81,23.54-1.81,2.72-2.49,2.95-17.43.9-19.47.45-4.53-3.62-4.53-5.21,2.72-32.82,2.94-36,7.66-8.31,7.66-8.31Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.31,282.09a29.16,29.16,0,0,1-4-.16c-2.28-.51-4.92-3.88-4.92-5.7,0-1,1.1-14,2-24.45.47-5.6.88-10.44,1-11.58.24-3.31,7.09-8.14,7.87-8.68a.5.5,0,0,1,.58,0l9.55,6.95a.42.42,0,0,1,.16.19c.17.37,4.12,9,4.58,15.8.47,7.13,1.58,22.18,1.8,23.49.3,1.8-2.17,3.28-2.83,3.5S146.93,282.09,141.31,282.09Zm2.19-49.54c-2.18,1.55-7,5.43-7.15,7.72-.08,1.15-.49,6-1,11.6-.84,9.86-2,23.37-2,24.36,0,1.29,2.23,4.3,4.14,4.72s18.18-.2,19.22-.44c.6-.2,2.29-1.42,2.13-2.38-.23-1.39-1.34-16.54-1.81-23.6-.42-6.2-4-14.26-4.43-15.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.47 217.04 144.96 224.9 143.51 231.93 151.37 238.55 155.09 230.28 154.88 214.97 142.47 217.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.37,239.05a.52.52,0,0,1-.32-.11l-7.87-6.62a.5.5,0,0,1-.16-.49l1.42-6.9L142,217.19a.46.46,0,0,1,.05-.41.5.5,0,0,1,.34-.24l12.41-2.06a.49.49,0,0,1,.58.48l.21,15.31a.49.49,0,0,1,0,.21l-3.73,8.28a.48.48,0,0,1-.34.28Zm-7.31-7.31,7.12,6,3.41-7.57-.2-14.61-11.27,1.88,2.31,7.31a.43.43,0,0,1,0,.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.02 221.18 142.26 223.45 143.3 225.93 147.85 223.66 147.02 221.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.3,226.43a.47.47,0,0,1-.17,0,.51.51,0,0,1-.29-.27l-1-2.49a.5.5,0,0,1,.25-.64l4.76-2.28a.53.53,0,0,1,.41,0,.54.54,0,0,1,.28.31l.83,2.48a.5.5,0,0,1-.26.6l-4.55,2.28A.42.42,0,0,1,143.3,226.43Zm-.39-2.73.64,1.55,3.69-1.85-.51-1.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.13,215.59l1,4.55s2.28,1.66,1.65,2.48a14.59,14.59,0,0,1-1.86,1.87s-1.45,6.82-2.48,7a13.27,13.27,0,0,1-7-1c-2.28-1.24-4.76-5.79-4.76-5.79l-.42-8.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,232.12a13,13,0,0,1-5.78-1.2c-2.38-1.29-4.86-5.8-5-6a.39.39,0,0,1-.06-.21l-.41-8.07a.49.49,0,0,1,.46-.52l13.86-1a.5.5,0,0,1,.52.39l1,4.37c.48.37,1.66,1.36,1.8,2.26a1.05,1.05,0,0,1-.2.81,14.44,14.44,0,0,1-1.8,1.84c-.7,3.22-1.74,7-2.84,7.25A8.71,8.71,0,0,1,159,232.12Zm-9.81-7.57c.37.66,2.56,4.44,4.51,5.5a13.16,13.16,0,0,0,6.69,1c.46-.32,1.47-3.7,2.09-6.65a.57.57,0,0,1,.17-.28,13.65,13.65,0,0,0,1.79-1.78c-.07-.51-1-1.35-1.55-1.77a.55.55,0,0,1-.2-.3l-.94-4.13-12.94,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.09,217.59l.64,3.46s6.94.77,9-.51.9-4.75,0-5.26S154.09,217.59,154.09,217.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,221.79a42.55,42.55,0,0,1-4.29-.24.5.5,0,0,1-.44-.41l-.64-3.46a.5.5,0,0,1,.34-.57c3.34-1.08,9.08-2.81,10-2.27a4.31,4.31,0,0,1,1.4,3.27A3.13,3.13,0,0,1,164,221C163,221.61,160.89,221.79,159,221.79Zm-3.81-1.2c2.12.21,6.83.44,8.3-.47a2.21,2.21,0,0,0,.91-2,3.53,3.53,0,0,0-.9-2.42c-.62-.17-4.89,1-8.81,2.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.85,218.07l27.31-2.69L164,213.11l-3.11-8.48a3.59,3.59,0,0,0-2.48-.83c-1.65,0-8.48-1.66-12.41.62S140.4,209.59,141.85,218.07Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.85,218.57a.49.49,0,0,1-.49-.41c-1.52-8.9.37-11.85,4.38-14.17,3.22-1.87,8.09-1.24,11-.87a16.54,16.54,0,0,0,1.66.18,4.15,4.15,0,0,1,2.84,1,.42.42,0,0,1,.11.18l3,8.28,5,2.2a.5.5,0,0,1-.15.95l-27.31,2.69Zm9.85-14.85a11.15,11.15,0,0,0-5.46,1.13c-3.64,2.11-5.26,4.67-4,12.68l24.94-2.46-3.42-1.51a.44.44,0,0,1-.27-.28l-3.06-8.36a3.29,3.29,0,0,0-2.06-.62,17.36,17.36,0,0,1-1.79-.18A37,37,0,0,0,151.7,203.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.73 221.05 143.82 220.54 143.31 219 154.09 217.59 154.73 221.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.73,221.55h0L143.8,221a.5.5,0,0,1-.45-.34l-.52-1.54a.5.5,0,0,1,0-.43.52.52,0,0,1,.36-.23L154,217.09a.49.49,0,0,1,.55.41l.65,3.46a.53.53,0,0,1-.12.42A.49.49,0,0,1,154.73,221.55Zm-10.54-1.49,9.94.46-.44-2.38L144,219.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.78,225.31h0a3,3,0,0,1-3-3V220a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3v2.27A3,3,0,0,1,148.78,225.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.78,225.81a3.5,3.5,0,0,1-3.5-3.5V220a3.5,3.5,0,0,1,7,0v2.27A3.5,3.5,0,0,1,148.78,225.81Zm0-8.27a2.5,2.5,0,0,0-2.5,2.5v2.27a2.5,2.5,0,0,0,5,0V220A2.5,2.5,0,0,0,148.78,217.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.02 229.01 154.35 236.97 153.45 241.6 140.87 232.74 142.02 229.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.45,242.1a.46.46,0,0,1-.29-.1l-12.58-8.85a.49.49,0,0,1-.19-.56l1.15-3.72a.56.56,0,0,1,.31-.33.52.52,0,0,1,.44.05l12.33,8a.52.52,0,0,1,.22.52l-.9,4.62a.5.5,0,0,1-.3.37A.65.65,0,0,1,153.45,242.1Zm-12-9.56,11.66,8.2.68-3.53-11.49-7.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.83,240.24s-2-.45-3.17,2.49-2,35.54-1.58,37.35a5.12,5.12,0,0,0,4.3,3.4c1.59,0,27.62-10.42,27.62-10.42l-.68-2.94-21.51.91,2-21.51",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.38,284a5.61,5.61,0,0,1-4.78-3.78c-.55-2.18.47-34.71,1.6-37.65,1-2.65,2.89-3,3.74-2.8a.5.5,0,0,1,.38.6.51.51,0,0,1-.59.38c-.08,0-1.65-.28-2.6,2.18-1,2.69-2.07,35-1.57,37a4.63,4.63,0,0,0,3.82,3c1.21-.05,16.68-6.08,27-10.22l-.49-2.12-21.09.89a.51.51,0,0,1-.39-.16.47.47,0,0,1-.13-.39l2-21.51a.51.51,0,0,1,.55-.45.5.5,0,0,1,.45.55l-2,20.93,20.93-.88a.52.52,0,0,1,.51.39l.68,2.94a.52.52,0,0,1-.3.58C163.82,275.27,142,284,140.38,284Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.32,270.12s3.59-2.87,4.05-3.94,3.53-1.54,4-1.69,1.07-1.07,1.53-.61,0,1.53-.46,1.68-2.91,1.54-2.91,1.54l5.67-.46a1,1,0,0,1,.31,1.22c-.31.77-1.69,1.38-1.69,1.38s-1.22,1.08-2.45,2-7.36,1.82-7.36,1.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,273.56a.5.5,0,0,1-.49-.38l-.68-2.95a.51.51,0,0,1,.18-.5c1.35-1.08,3.61-3.05,3.9-3.75.44-1,2.22-1.49,3.85-1.86l.44-.1a2.38,2.38,0,0,0,.35-.25c.35-.28,1.07-.87,1.7-.25a1.36,1.36,0,0,1,.28,1.29,1.67,1.67,0,0,1-.94,1.23c-.11,0-.39.18-.76.37l3.32-.27a.49.49,0,0,1,.34.1,1.53,1.53,0,0,1,.47,1.81,3.94,3.94,0,0,1-1.87,1.62c-.26.22-1.34,1.15-2.43,2-1.29,1-6.95,1.82-7.59,1.92Zm-.12-3.25.5,2.19c2.36-.37,5.91-1.09,6.68-1.66,1.2-.9,2.41-2,2.42-2a.35.35,0,0,1,.13-.08,3.15,3.15,0,0,0,1.42-1.11.53.53,0,0,0,0-.52l-5.44.44a.5.5,0,0,1-.29-.94c.42-.23,2.52-1.41,3-1.57a.93.93,0,0,0,.3-.57.41.41,0,0,0,0-.29,2.85,2.85,0,0,1-.36.31,2.49,2.49,0,0,1-.66.43l-.55.13c-.71.16-2.86.64-3.14,1.28C171.4,267.4,168.83,269.54,167.88,270.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.89,375.39a18.64,18.64,0,0,0,4.75,4.3c2.49,1.36,6.79,2.94,6.79,4.07v1.14H141.51l.23-10Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.43,385.4H141.51a.51.51,0,0,1-.5-.52l.23-10a.48.48,0,0,1,.16-.35.46.46,0,0,1,.37-.13l8.15.45a.54.54,0,0,1,.37.19,18.2,18.2,0,0,0,4.59,4.17c.7.38,1.57.79,2.41,1.19,2.88,1.36,4.64,2.25,4.64,3.32v1.14A.5.5,0,0,1,161.43,385.4Zm-19.41-1h18.91v-.64c-.08-.53-2.68-1.76-4.07-2.42-.85-.4-1.73-.82-2.46-1.21a18.42,18.42,0,0,1-4.76-4.25l-7.41-.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.51,384.9h19.92v-1.14c0-.32-.36-.69-.93-1.07H141.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.43,385.4H141.51a.51.51,0,0,1-.5-.52l.05-2.21a.5.5,0,0,1,.5-.48H160.5a.54.54,0,0,1,.28.08c.54.37,1.15.87,1.15,1.49v1.14A.5.5,0,0,1,161.43,385.4Zm-19.41-1h18.91v-.64s0-.18-.59-.57H142.05Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-141"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.75,
    y: 270.62,
    width: 30.22,
    height: 25.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,296.49H291.75a.5.5,0,0,1-.5-.5V270.62a.5.5,0,0,1,.5-.5H322a.5.5,0,0,1,.5.5V296A.5.5,0,0,1,322,296.49Zm-29.73-1h29.23V271.12H292.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.54,
    y: 270.62,
    width: 22.09,
    height: 25.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.63,296.49H304.54a.5.5,0,0,1-.5-.5V270.62a.5.5,0,0,1,.5-.5h22.09a.5.5,0,0,1,.5.5V296A.5.5,0,0,1,326.63,296.49Zm-21.59-1h21.09V271.12H305Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--robotic-arm-3--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M372.45,266.48h39.3A13.25,13.25,0,0,1,425,279.73v50.75a0,0,0,0,1,0,0H367.5a0,0,0,0,1,0,0v-59A5,5,0,0,1,372.45,266.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,331H367.5a.5.5,0,0,1-.5-.5V271.43a5.46,5.46,0,0,1,5.45-5.45h39.3a13.77,13.77,0,0,1,13.75,13.75v50.75A.5.5,0,0,1,425,331Zm-57-1h56.5V279.73A12.76,12.76,0,0,0,411.75,267h-39.3a4.46,4.46,0,0,0-4.45,4.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.25,317h66a6.75,6.75,0,0,1,6.75,6.75V336a0,0,0,0,1,0,0H356.5a0,0,0,0,1,0,0V323.73A6.75,6.75,0,0,1,363.25,317Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,336.48H356.5a.5.5,0,0,1-.5-.5V323.73a7.26,7.26,0,0,1,7.25-7.25h66a7.26,7.26,0,0,1,7.25,7.25V336A.5.5,0,0,1,436,336.48Zm-79-1h78.5V323.73a6.25,6.25,0,0,0-6.25-6.25h-66a6.25,6.25,0,0,0-6.25,6.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.75,334.48h97a4.25,4.25,0,0,1,4.25,4.25v46.74a0,0,0,0,1,0,0H343.5a0,0,0,0,1,0,0V338.73A4.25,4.25,0,0,1,347.75,334.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,386H343.5a.5.5,0,0,1-.5-.5V338.73a4.75,4.75,0,0,1,4.75-4.75h97a4.75,4.75,0,0,1,4.75,4.75v46.74A.5.5,0,0,1,449,386Zm-105-1H448.5V338.73a3.75,3.75,0,0,0-3.75-3.75h-97a3.75,3.75,0,0,0-3.75,3.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.12,317.06a.5.5,0,0,1-.5-.5V304.37a.5.5,0,0,1,.5-.5h22V266.48a.5.5,0,0,1,1,0v37.89a.5.5,0,0,1-.5.5h-22v11.69A.5.5,0,0,1,390.12,317.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.47,289.36H412.65a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h11.82a.5.5,0,0,1,.5.5A.5.5,0,0,1,424.47,289.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.84,
    y: 223.79,
    width: 45.33,
    height: 8.67,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.17,233H353.84a.5.5,0,0,1-.5-.5v-8.66a.5.5,0,0,1,.5-.5h45.33a.5.5,0,0,1,.5.5v8.66A.5.5,0,0,1,399.17,233Zm-44.83-1h44.33v-7.66H354.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.3,232.73a.51.51,0,0,1-.5-.5v-8.55a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.55A.5.5,0,0,1,368.3,232.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.33,232.73a.5.5,0,0,1-.5-.5v-8.55a.5.5,0,0,1,1,0v8.55A.5.5,0,0,1,371.33,232.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.36,232.73a.5.5,0,0,1-.5-.5v-8.55a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.55A.51.51,0,0,1,374.36,232.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.38,232.73a.51.51,0,0,1-.5-.5v-8.55a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.55A.5.5,0,0,1,377.38,232.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.41,232.73a.5.5,0,0,1-.5-.5v-8.55a.5.5,0,0,1,1,0v8.55A.5.5,0,0,1,380.41,232.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.44,232.73a.5.5,0,0,1-.5-.5v-8.55a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.55A.51.51,0,0,1,383.44,232.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.46,232.73a.51.51,0,0,1-.5-.5v-8.55a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v8.55A.5.5,0,0,1,386.46,232.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.5,230.56,394,279.33A9.15,9.15,0,0,1,382.35,285h0a9.16,9.16,0,0,1-5.68-11.65l13.5-48.78a9.17,9.17,0,0,1,11.65-5.68h0A9.17,9.17,0,0,1,407.5,230.56Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.33,286a9.84,9.84,0,0,1-3.14-.52,9.67,9.67,0,0,1-6-12.29l13.49-48.75A9.66,9.66,0,1,1,408,230.7l-13.49,48.77A9.71,9.71,0,0,1,385.33,286Zm13.5-67.11a8.69,8.69,0,0,0-8.19,5.85L377.15,273.5a8.67,8.67,0,1,0,16.38,5.67L407,230.42a0,0,0,0,1,0,0,8.68,8.68,0,0,0-8.2-11.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.67 269.64 339.94 262.41 329.54 255.52 327.67 269.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.67,270.14a.53.53,0,0,1-.27-.08.49.49,0,0,1-.22-.48l1.87-14.12a.5.5,0,0,1,.28-.39.51.51,0,0,1,.49,0l10.4,6.89a.47.47,0,0,1,.22.42.49.49,0,0,1-.24.42l-12.27,7.23A.48.48,0,0,1,327.67,270.14Zm2.26-13.76-1.63,12.31,10.7-6.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.31,
    y: 222.43,
    width: 7,
    height: 33.61,
    transform: "translate(189.95 -152.29) rotate(33.52)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.45,255.67a.45.45,0,0,1-.27-.08l-5.84-3.86a.49.49,0,0,1-.21-.32.51.51,0,0,1,.07-.38l18.56-28a.49.49,0,0,1,.69-.15l5.84,3.87a.47.47,0,0,1,.21.32.48.48,0,0,1-.07.37l-18.56,28A.5.5,0,0,1,341.45,255.67Zm-5.14-4.5,5,3.31,18-27.18-5-3.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.12,235.89h15a0,0,0,0,1,0,0v23.7a1.76,1.76,0,0,1-1.76,1.76H335.88a1.76,1.76,0,0,1-1.76-1.76v-23.7a0,0,0,0,1,0,0Z",
    transform: "translate(194.11 -147.29) rotate(33.52)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.3,263.19a2.26,2.26,0,0,1-1.24-.38l-9.54-6.31a2.28,2.28,0,0,1-.64-3.14L342,233.6a.51.51,0,0,1,.7-.14l12.47,8.26a.5.5,0,0,1,.14.69l-13.09,19.76A2.27,2.27,0,0,1,340.3,263.19Zm2.23-28.62-12.81,19.34a1.27,1.27,0,0,0-.19,1,1.25,1.25,0,0,0,.54.8l9.54,6.32h0a1.27,1.27,0,0,0,1.75-.36l12.81-19.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.84,
    cy: 227.12,
    r: 9.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.84,237.12a10,10,0,1,1,10-10A10,10,0,0,1,355.84,237.12Zm0-19a9,9,0,1,0,9,9A9,9,0,0,0,355.84,218.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.84,
    cy: 227.12,
    r: 4.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.84,232.12a5,5,0,1,1,5-5A5,5,0,0,1,355.84,232.12Zm0-9a4,4,0,1,0,4,4A4,4,0,0,0,355.84,223.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.17,
    cy: 227.12,
    r: 9.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.17,237.12a10,10,0,1,1,10-10A10,10,0,0,1,399.17,237.12Zm0-19a9,9,0,1,0,9,9A9,9,0,0,0,399.17,218.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.17,
    cy: 227.12,
    r: 4.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.17,232.12a5,5,0,1,1,5-5A5,5,0,0,1,399.17,232.12Zm0-9a4,4,0,1,0,4,4A4,4,0,0,0,399.17,223.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.41,
    cy: 276.34,
    r: 9.5,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.41,286.34a10,10,0,1,1,10-10A10,10,0,0,1,385.41,286.34Zm0-19a9,9,0,1,0,9,9A9,9,0,0,0,385.41,267.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.41,
    cy: 276.34,
    r: 4.5,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.41,281.34a5,5,0,1,1,5-5A5,5,0,0,1,385.41,281.34Zm0-9a4,4,0,1,0,4,4A4,4,0,0,0,385.41,272.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.83,266.32a.5.5,0,0,1-.48-.35l-1.48-4.74a.49.49,0,0,1,.32-.63.51.51,0,0,1,.63.33l1.48,4.74a.51.51,0,0,1-.33.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.16,268.1a.5.5,0,0,1-.29-.09l-4.16-3a.5.5,0,1,1,.59-.81l4.15,3a.51.51,0,0,1,.11.7A.48.48,0,0,1,323.16,268.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.79,271.36h0l-5-.3a.5.5,0,0,1,.06-1l5,.3a.5.5,0,0,1,.47.53A.49.49,0,0,1,336.79,271.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.05,279.07a.5.5,0,0,1-.45-.28l-3-5.93a.51.51,0,0,1,.22-.67.5.5,0,0,1,.67.23l3,5.92a.51.51,0,0,1-.23.68A.54.54,0,0,1,332.05,279.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.61,275.51a.54.54,0,0,1-.25-.06l-2.07-1.19a.49.49,0,0,1-.19-.68.51.51,0,0,1,.68-.19l2.08,1.19a.5.5,0,0,1-.25.93Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--robotic-arm-2--inject-141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.4,156.7h-4.61a.5.5,0,0,1-.5-.5V98.44a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V155.7h3.61v-57a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V156.2A.5.5,0,0,1,298.4,156.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.75,247.49a2,2,0,0,1-2-2V227.81a2,2,0,0,1,4,0v17.68A2,2,0,0,1,276.75,247.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.25,229.36a2,2,0,0,1-1.07-3.7L295,213.85a2,2,0,0,1,2.13,3.39l-18.85,11.81A2,2,0,0,1,277.25,229.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.54,227.81a3.79,3.79,0,1,0-3.79,3.79A3.79,3.79,0,0,0,280.54,227.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.75,232.1a4.29,4.29,0,1,1,4.29-4.29A4.29,4.29,0,0,1,276.75,232.1Zm0-7.58a3.29,3.29,0,1,0,3.29,3.29A3.29,3.29,0,0,0,276.75,224.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.54,227.81a1.8,1.8,0,1,0-1.79,1.8A1.79,1.79,0,0,0,278.54,227.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.75,230.11a2.3,2.3,0,1,1,2.29-2.3A2.3,2.3,0,0,1,276.75,230.11Zm0-3.59a1.3,1.3,0,1,0,1.29,1.29A1.3,1.3,0,0,0,276.75,226.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.31,247.49a2,2,0,0,1-2-2V227.81a2,2,0,0,1,4,0v17.68A2,2,0,0,1,315.31,247.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,229.36a2,2,0,0,1-1.06-.31l-18.84-11.81a2,2,0,0,1,2.12-3.39l18.85,11.81a2,2,0,0,1-1.07,3.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.52,227.81a3.79,3.79,0,1,1,3.79,3.79A3.79,3.79,0,0,1,311.52,227.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.31,232.1a4.29,4.29,0,1,1,4.29-4.29A4.3,4.3,0,0,1,315.31,232.1Zm0-7.58a3.29,3.29,0,1,0,3.29,3.29A3.3,3.3,0,0,0,315.31,224.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.52,227.81a1.8,1.8,0,1,1,1.79,1.8A1.79,1.79,0,0,1,313.52,227.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.31,230.11a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,315.31,230.11Zm0-3.59a1.3,1.3,0,1,0,1.3,1.29A1.29,1.29,0,0,0,315.31,226.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.66,
    y: 146.42,
    width: 8.86,
    height: 58.61,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.52,205.54h-8.86a.51.51,0,0,1-.5-.5V146.42a.51.51,0,0,1,.5-.5h8.86a.5.5,0,0,1,.5.5V205A.5.5,0,0,1,300.52,205.54Zm-8.36-1H300V146.92h-7.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.09,225.67h0A10.12,10.12,0,0,1,286,215.54V175.6h20.25v39.94A10.12,10.12,0,0,1,296.09,225.67Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.09,226.17a10.64,10.64,0,0,1-10.62-10.63V175.6a.5.5,0,0,1,.5-.5h20.25a.5.5,0,0,1,.5.5v39.94A10.64,10.64,0,0,1,296.09,226.17Zm-9.62-50.07v39.44a9.63,9.63,0,1,0,19.25,0V176.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.74,
    y: 173.96,
    width: 24.7,
    height: 6.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.44,180.65h-24.7a.51.51,0,0,1-.5-.5V174a.5.5,0,0,1,.5-.5h24.7a.5.5,0,0,1,.5.5v6.19A.5.5,0,0,1,308.44,180.65Zm-24.2-1h23.7v-5.19h-23.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.09,
    cy: 215.54,
    r: 8.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.09,224.06a8.52,8.52,0,1,1,8.52-8.52A8.52,8.52,0,0,1,296.09,224.06Zm0-16a7.52,7.52,0,1,0,7.52,7.51A7.52,7.52,0,0,0,296.09,208Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.09,
    cy: 215.54,
    r: 3.8,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.09,219.84a4.3,4.3,0,1,1,4.3-4.3A4.31,4.31,0,0,1,296.09,219.84Zm0-7.59a3.3,3.3,0,1,0,3.3,3.29A3.3,3.3,0,0,0,296.09,212.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.83,
    y: 185.09,
    width: 4.34,
    height: 18.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.18,203.77h-4.35a.5.5,0,0,1-.5-.5V185.09a.5.5,0,0,1,.5-.5h4.35a.5.5,0,0,1,.5.5v18.18A.5.5,0,0,1,292.18,203.77Zm-3.85-1h3.35V185.59h-3.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.05,
    y: 185.09,
    width: 4.34,
    height: 18.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.39,203.77h-4.34a.5.5,0,0,1-.5-.5V185.09a.5.5,0,0,1,.5-.5h4.34a.5.5,0,0,1,.5.5v18.18A.5.5,0,0,1,304.39,203.77Zm-3.84-1h3.34V185.59h-3.34Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--robotic-arm-1--inject-141"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.85,
    y: 242.62,
    width: 30.22,
    height: 25.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.07,268.49H207.85a.5.5,0,0,1-.5-.5V242.62a.5.5,0,0,1,.5-.5h30.22a.5.5,0,0,1,.5.5V268A.5.5,0,0,1,238.07,268.49Zm-29.72-1h29.22V243.12H208.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.64,
    y: 242.62,
    width: 22.09,
    height: 25.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.72,268.49H220.64a.5.5,0,0,1-.5-.5V242.62a.5.5,0,0,1,.5-.5h22.08a.5.5,0,0,1,.5.5V268A.5.5,0,0,1,242.72,268.49Zm-21.58-1h21.08V243.12H221.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.64,156.7H223a.5.5,0,0,1-.5-.5V98.44a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V155.7h3.61v-57a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V156.2A.5.5,0,0,1,227.64,156.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,247.49a2,2,0,0,1-2-2V227.81a2,2,0,0,1,4,0v17.68A2,2,0,0,1,206,247.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.49,229.36a2,2,0,0,1-1.06-3.7l18.85-11.81a2,2,0,0,1,2.12,3.39l-18.85,11.81A2,2,0,0,1,206.49,229.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.79,227.81a3.8,3.8,0,1,0-3.8,3.79A3.8,3.8,0,0,0,209.79,227.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,232.1a4.29,4.29,0,1,1,4.3-4.29A4.3,4.3,0,0,1,206,232.1Zm0-7.58a3.29,3.29,0,1,0,3.3,3.29A3.3,3.3,0,0,0,206,224.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.79,227.81a1.8,1.8,0,1,0-1.8,1.8A1.79,1.79,0,0,0,207.79,227.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,230.11a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,206,230.11Zm0-3.59a1.3,1.3,0,1,0,1.3,1.29A1.29,1.29,0,0,0,206,226.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.56,247.49a2,2,0,0,1-2-2V227.81a2,2,0,0,1,4,0v17.68A2,2,0,0,1,244.56,247.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.06,229.36a2,2,0,0,1-1.06-.31l-18.85-11.81a2,2,0,0,1,2.13-3.39l18.84,11.81a2,2,0,0,1-1.06,3.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.77,227.81a3.79,3.79,0,1,1,3.79,3.79A3.79,3.79,0,0,1,240.77,227.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.56,232.1a4.29,4.29,0,1,1,4.29-4.29A4.29,4.29,0,0,1,244.56,232.1Zm0-7.58a3.29,3.29,0,1,0,3.29,3.29A3.29,3.29,0,0,0,244.56,224.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.76,227.81a1.8,1.8,0,1,1,1.8,1.8A1.8,1.8,0,0,1,242.76,227.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.56,230.11a2.3,2.3,0,1,1,2.29-2.3A2.3,2.3,0,0,1,244.56,230.11Zm0-3.59a1.3,1.3,0,1,0,1.29,1.29A1.3,1.3,0,0,0,244.56,226.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.91,
    y: 146.42,
    width: 8.86,
    height: 58.61,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.77,205.54h-8.86a.5.5,0,0,1-.5-.5V146.42a.5.5,0,0,1,.5-.5h8.86a.51.51,0,0,1,.5.5V205A.51.51,0,0,1,229.77,205.54Zm-8.36-1h7.86V146.92h-7.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34,225.67h0a10.12,10.12,0,0,1-10.13-10.13V175.6h20.25v39.94A10.12,10.12,0,0,1,225.34,225.67Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34,226.17a10.64,10.64,0,0,1-10.63-10.63V175.6a.5.5,0,0,1,.5-.5h20.25a.5.5,0,0,1,.5.5v39.94A10.64,10.64,0,0,1,225.34,226.17Zm-9.63-50.07v39.44a9.63,9.63,0,1,0,19.25,0V176.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.99,
    y: 173.96,
    width: 24.7,
    height: 6.19,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.69,180.65H213a.5.5,0,0,1-.5-.5V174a.5.5,0,0,1,.5-.5h24.7a.5.5,0,0,1,.5.5v6.19A.51.51,0,0,1,237.69,180.65Zm-24.2-1h23.7v-5.19h-23.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.34,
    cy: 215.54,
    r: 8.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34,224.06a8.52,8.52,0,1,1,8.51-8.52A8.53,8.53,0,0,1,225.34,224.06Zm0-16a7.52,7.52,0,1,0,7.51,7.51A7.52,7.52,0,0,0,225.34,208Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.34,
    cy: 215.54,
    r: 3.8,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34,219.84a4.3,4.3,0,1,1,4.3-4.3A4.31,4.31,0,0,1,225.34,219.84Zm0-7.59a3.3,3.3,0,1,0,3.3,3.29A3.3,3.3,0,0,0,225.34,212.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.08,
    y: 185.09,
    width: 4.34,
    height: 18.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,203.77h-4.34a.5.5,0,0,1-.5-.5V185.09a.5.5,0,0,1,.5-.5h4.34a.5.5,0,0,1,.5.5v18.18A.5.5,0,0,1,221.42,203.77Zm-3.84-1h3.34V185.59h-3.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.3,
    y: 185.09,
    width: 4.34,
    height: 18.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.64,203.77h-4.35a.5.5,0,0,1-.5-.5V185.09a.5.5,0,0,1,.5-.5h4.35a.5.5,0,0,1,.5.5v18.18A.5.5,0,0,1,233.64,203.77Zm-3.85-1h3.35V185.59h-3.35Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-141"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.61,
    y: 384.89,
    width: 404.99,
    height: 4.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.6,389.43h-405a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,.5-.5h405a.51.51,0,0,1,.5.5v4A.5.5,0,0,1,458.6,389.43Zm-404.49-1h404v-3h-404Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg2);
export default __webpack_public_path__ + "static/media/svg-2.090b37aa24c317592d5f246e027f51df.svg";
export { ForwardRef as ReactComponent };